import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const draggableCardSlotRecipe = defineSlotRecipe({
  className: 'draggable-card',
  slots: ['root', 'handle', 'content'],
  base: {
    root: {
      alignItems: 'stretch',
      backgroundColor: 'background/primary',
      border: '1px solid',
      borderColor: 'border/minimal',
      borderRadius: '8',
      boxShadow: 'elevation/sm',
      display: 'flex',
      overflow: 'hidden',
    },
    handle: {
      alignItems: 'center',
      color: 'icon/tertiary',
      display: 'flex',
      flexShrink: 0,
      justifyContent: 'center',
      width: '24',
    },
    content: {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      paddingBlock: '16',
      paddingInlineEnd: '16',
    },
  },
  variants: {
    isDragging: {
      true: {
        root: {
          borderColor: 'border/strong',
          boxShadow: 'elevation/lg',
          cursor: 'grabbing',
        },
        handle: {
          color: 'icon/secondary',
        },
      },
    },
    isDropTarget: {
      true: {
        root: {
          background: 'background/secondary',
          borderColor: 'border/strong',
          borderStyle: 'dashed',
          boxShadow: 'none',
        },
        handle: {
          visibility: 'hidden',
        },
        content: {
          visibility: 'hidden',
        },
      },
    },
    isFullCardDrag: {
      true: {
        root: {
          cursor: 'grab',
          _hover: {
            borderColor: 'border/regular',
            _active: {
              borderColor: 'border/strong',
            },
          },
          _active: {
            borderColor: 'border/strong',
          },
        },
        handle: {
          pointerEvents: 'none',
        },
        content: {
          paddingInlineStart: 0,
        },
      },
      false: {
        root: {
          _hover: {
            borderColor: 'border/regular',
          },
        },
        handle: {
          appearance: 'none',
          background: 'transparent',
          border: 'none',
          cursor: 'grab',
          focusVisibleRing: 'none',
          _focusVisible: {
            boxShadow: 'inset 0 0 0 var(--focus-ring-width) var(--focus-ring-color)',
          },
          _hover: {
            background: 'background/hover',
            color: 'icon/secondary',
            _active: {
              background: 'background/active',
            },
          },
          _active: {
            background: 'background/active',
          },
        },
        content: {
          paddingInlineStart: '8',
        },
      },
    },
  },
  compoundVariants: [
    {
      isDragging: true,
      isFullCardDrag: true,
      css: {
        root: {
          cursor: 'grabbing',
          _hover: {
            borderColor: 'border/strong',
          },
        },
      },
    },
    {
      isDragging: true,
      isFullCardDrag: false,
      css: {
        root: {
          _hover: {
            borderColor: 'border/strong',
          },
        },
        handle: {
          background: 'background/active',
          cursor: 'grabbing',
          _hover: {
            background: 'background/active',
          },
        },
      },
    },
    {
      isDropTarget: true,
      isFullCardDrag: true,
      css: {
        root: {
          cursor: 'default',
          _hover: {
            borderColor: 'border/strong',
          },
        },
      },
    },
    {
      isDropTarget: true,
      isFullCardDrag: false,
      css: {
        root: {
          _hover: {
            borderColor: 'border/strong',
          },
        },
      },
    },
  ],
  defaultVariants: {
    isDragging: false,
    isDropTarget: false,
    isFullCardDrag: true,
  },
});

export default draggableCardSlotRecipe;
